var exports = {
  "vN": "ProfilePreview.module__messageIcon___bnB2aE",
  "pM": "ProfilePreview.module__previewInteractive___bnB2aE",
  "l5": "ProfilePreview.module__messageButtonWrapper___bnB2aE",
  "bc": "ProfilePreview.module__profileCustomStatus___bnB2aE",
  "CQ": "ProfilePreview.module__profileCustomStatusText___bnB2aE",
};

module.exports = exports;
